import React from "react";

const ShriMataji = () => {
  return (
    <section className="bg-[#f5f9f8] py-16 px-4 sm:px-6 lg:px-20">
      {/* Image + Text */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Image */}
        <div data-aos="fade-right" className="w-full">
          <img
            src="/Website-Photos-1.png"
            alt="Shri Mataji Nirmala Devi"
            className="w-full h-auto rounded-xl shadow-md border border-green-200"
          />
        </div>

        {/* Text */}
        <div data-aos="fade-left" className="w-full">
          <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4">
            Shri Mataji Nirmala Devi
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Shri Mataji Nirmala Devi (1923–2011) was the founder of Sahaja Yoga. Through Her
            spiritual wisdom, She enabled countless people to experience self-realization and inner peace.
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            Born in India, She combined deep spiritual insight with a practical vision for humanity’s inner transformation.
            Her teachings are universal, accessible, and always free.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Sahaja Yoga now has centers across the globe, continuing to spread Her message of love, balance, and peace.
          </p>
        </div>
      </div>

      {/* Video Section */}
      {/* Video Section */}
<div className="mt-16 max-w-4xl mx-auto text-center px-2">
  <h3 className="text-2xl md:text-3xl font-semibold text-green-800 mb-6">
    Introduction to Sahaja Yoga by Shri Mataji
  </h3>
  <div className="w-full aspect-video rounded-lg shadow-md overflow-hidden border border-green-200">
    <iframe
      src="https://www.youtube.com/embed/tO3YXqOY5wc?si=y2vsMhvRAa8osSf-"
      title="Shri Mataji Introduction to Sahaja Yoga"
      className="w-full h-full"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</div>

    </section>
  );
};

export default ShriMataji;
